import React from 'react';
import { Button } from '../Button';
import { useSelectContext } from './SelectContext';
import { ChevronDown, ChevronUp } from '../Icons';

interface SelectTriggerProps {
  className?: string;
  children: React.ReactNode;
  options?: {
    usePrimaryVariantWhenSelected: boolean;
  };
}

export const SelectTrigger: React.FC<SelectTriggerProps> = ({
  className,
  children,
  options = {
    usePrimaryVariantWhenSelected: false,
  },
}) => {
  const { isOpen, value, optionsMap, setIsOpen, refs } = useSelectContext();

  const toggleDropdown = () => setIsOpen(!isOpen);

  const isSelected = optionsMap?.[value] ?? false;

  return (
    <Button
      variant={
        options?.usePrimaryVariantWhenSelected && isSelected
          ? 'primary'
          : 'secondary'
      }
      ref={refs.setReference}
      className={`justify-start ${className}`}
      onClick={toggleDropdown}
      aria-haspopup="listbox"
      aria-expanded={isOpen}
    >
      {children}{' '}
      <div className="ml-auto">{isOpen ? <ChevronUp /> : <ChevronDown />}</div>
    </Button>
  );
};
